import { forwardRef, type MouseEvent } from 'react';

import { CalendarRangeIcon, XIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Input, type InputProps } from '@air/primitive-input';
import { cn } from '@air/utils-tailwind';

export type DateInputFieldProps = {
  onClear?: (e: MouseEvent<HTMLButtonElement>) => void;
  showCalendarIcon?: boolean;
} & InputProps;

export const DateInputField = forwardRef<HTMLInputElement | null, DateInputFieldProps>(
  ({ showCalendarIcon = true, className, size, onClear, ...props }: DateInputFieldProps, ref) => {
    const showClearIcon = !!onClear && !!props.value;

    return (
      <div className="relative flex">
        {showCalendarIcon && (
          <CalendarRangeIcon className="absolute top-1/2 left-3 -translate-y-1/2 text-gray-11" size="sm" />
        )}
        <Input
          className={cn('w-full', showCalendarIcon ? 'pl-9' : '', showClearIcon ? 'pr-8' : '', className)}
          ref={ref}
          size={size}
          {...props}
        />
        {showClearIcon && (
          <IconButton
            adsIcon
            appearance="ghost"
            className="absolute top-1/2 right-1.5 -translate-y-1/2"
            color="gray"
            icon={XIcon}
            label="Clear"
            onClick={onClear}
            size="small"
          />
        )}
      </div>
    );
  },
);

DateInputField.displayName = 'DateInputField';
